<template>
  <div class="wrapper">
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="deleteSoftware"
    >
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    deleteSoftware: function () {
      this.params.context.componentParent.deleteSoftware(this.params.data);
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 68px;
  display: flex;
  align-items: center;
}
</style>
